import axios from 'axios';
import { getAccessToken, getUser } from './AuthService';

/**
 * Backend contract for Stripe Embedded Checkout (free trial)
 * ------------------------------------------------------------------
 * Endpoint: POST /dev/checkout/session (auth required)
 * Headers:  x-api-key, Authorization: Bearer <accessToken>
 * Body:     { user, token, returnUrl }
 *
 * Expected response:
 *   { clientSecret: string }  // Stripe Checkout Session client_secret
 *   Session must be created with:
 *     ui_mode: 'embedded'
 *     mode: 'subscription'
 *     subscription_data.trial_period_days (or trial on Price)
 *     client_reference_id / metadata tied to Cognito user id + email
 *
 * Webhooks (backend):
 *   - checkout.session.completed
 *   - customer.subscription.created / updated / deleted
 *   → persist subscriptionStatus (trialing | active | canceled | past_due)
 *     on the user record and return it from /login and /verify.
 *
 * Frontend return_url:
 *   /daily-content?checkout=success
 *   On load, app calls /verify to refresh entitlements.
 */

const DEFAULT_API_KEY = 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB';
const CHECKOUT_SESSION_URL =
    'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/checkout/session';

const requestConfig = {
    headers: {
        'x-api-key': process.env.REACT_APP_AWS_API_GATEWAY_KEY || DEFAULT_API_KEY,
    },
};

export function getStripePublishableKey() {
    return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
}

export async function createEmbeddedCheckoutSession(returnUrl) {
    const token = getAccessToken();
    const user = getUser();

    if (!token || !user) {
        throw new Error('You must be signed in to start a free trial.');
    }

    const response = await axios.post(
        CHECKOUT_SESSION_URL,
        { user, token, returnUrl },
        {
            ...requestConfig,
            headers: {
                ...requestConfig.headers,
                Authorization: `Bearer ${token}`,
            },
        }
    );

    const clientSecret = response.data?.clientSecret;
    if (!clientSecret) {
        throw new Error('Billing setup unavailable. Please try again later.');
    }

    return clientSecret;
}
